module.exports = __webpack_public_path__ + "img/more.0c942eb0.png";